import * as React from 'react';
import { Flex, FormControl, FormErrorMessage, FormLabel, GridItem, Text } from '@chakra-ui/react';
import { SYSTEM_TRANSLATION_DEFAULTS } from '@common/entities';
import { sizeFormFields } from '@common/ui';

interface FieldProps {
  children: React.ReactElement;
  name: string;
  label: string;
  description?: string;
  required?: boolean;
  labelProps?: any;
  placeholder?: string;
  fieldType?: string;
  fieldState?: any;
  errorMessage?: string;
  showValidationErrorMessage?: boolean;
  footerText?: string;
}

export function FieldWrapper({
  name,
  label,
  description,
  required,
  children,
  fieldState = {},
  labelProps,
  fieldType,
  footerText,
}: FieldProps) {
  return (
    <GridItem my={1} colSpan={sizeFormFields(fieldType || '')}>
      <FormControl id={`${name}`} isDisabled isInvalid={fieldState.invalid}>
        {description && <FormLabel mb={2}>{description}</FormLabel>}
        <Flex justifyContent="space-between">
          <FormLabel {...labelProps}>{label}</FormLabel>
          {!required && <Text variant="OptionalField">Optional</Text>}
        </Flex>
        {children}
        {footerText && (
          <Text color="yellow.darkest" fontSize="0.688rem" mt={1}>
            {SYSTEM_TRANSLATION_DEFAULTS[footerText] ?? footerText}
          </Text>
        )}
        {fieldState.invalid && (
          <FormErrorMessage color="red.base" fontSize="0.688rem" pos="absolute" bottom="-16px">
            {fieldState?.error?.message || 'This field is required'}
          </FormErrorMessage>
        )}
      </FormControl>
    </GridItem>
  );
}
